import { API_CONFIG } from './config/api'
import { apiGet } from '../shared/utils/apiClient'
import type {
  BoxDto,
  FindAllBoxesResponseDto,
  BoxesControllerFindAllParamsOrderByEnum,
  BoxesControllerFindAllParamsOrderDirectionEnum,
} from '../types/generated'

// Pagination constants
export const DEFAULT_PAGINATION = { page: 1, limit: 10 } as const

// Box filtering and query types
export type BoxStatus = 'all' | 'active' | 'finished'
export type BoxOrderBy = BoxesControllerFindAllParamsOrderByEnum
export type BoxOrderDirection = BoxesControllerFindAllParamsOrderDirectionEnum

export interface BoxQueryParams {
  status?: BoxStatus
  orderBy?: BoxOrderBy
  orderDirection?: BoxOrderDirection
  page?: number
  limit?: number
}

// Re-export types for convenience
export type {
  BoxDto,
  FindAllBoxesResponseDto,
  BoxesControllerFindAllParamsOrderByEnum,
  BoxesControllerFindAllParamsOrderDirectionEnum,
}

export const getBoxes = async (
  params: BoxQueryParams = {},
): Promise<FindAllBoxesResponseDto> => {
  const {
    status = 'all',
    page = DEFAULT_PAGINATION.page,
    limit = DEFAULT_PAGINATION.limit,
    orderBy,
    orderDirection,
  } = params

  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  })

  if (status !== 'all') {
    queryParams.append('status', status)
  }

  if (orderBy) {
    queryParams.append('orderBy', orderBy)
  }

  if (orderDirection) {
    queryParams.append('orderDirection', orderDirection)
  }

  // Public endpoint - works without auth, but will include token if available
  const response = await apiGet(
    `${API_CONFIG.endpoints.boxes.getAll}?${queryParams.toString()}`,
  )

  if (!response.ok) {
    throw new Error(
      `Failed to fetch boxes: ${response.status} ${response.statusText}`,
    )
  }

  return response.json()
}

export const getBoxById = async (id: string | number): Promise<BoxDto> => {
  // Public endpoint - works without auth, but will include token if available
  const response = await apiGet(API_CONFIG.endpoints.boxes.getById(id))

  if (!response.ok) {
    throw new Error(
      `Failed to fetch box: ${response.status} ${response.statusText}`,
    )
  }

  return response.json()
}
